import { render, staticRenderFns } from "./PetDetailsSection.vue?vue&type=template&id=790f902f"
import script from "./PetDetailsSection.vue?vue&type=script&lang=js"
export * from "./PetDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports